import React, { useState, useEffect } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { useCompanyContext } from '../../../contexts/Company';
import { useLinesContext } from '../../../contexts/Lines';
import { IProduct as Product } from '../../../Types';
import { formatNumber, getLinePageWidth } from '../../../utils';
import Stepper from '../../../components/Onboarding/BuildingBlocks/OnboardingWrapper';
import PageLayout from '../../../components/Onboarding/Line/CreateLine';

function getHeader(mobile: boolean) {
  const DESKTOP_HEADER = "Let's build your first Line";
  const MOBILE_HEADER =
    'Great! Let’s build the first Line for the product you chose.';
  return mobile ? MOBILE_HEADER : DESKTOP_HEADER;
}

function getSubTitle(mobile: boolean, newestProduct: Product) {
  if (!mobile) {
    const productName =
      newestProduct?.name?.length > 20
        ? newestProduct.name.slice(0, 21) + '...'
        : newestProduct?.name;

    return (
      <span>
        Enter the supply chain costs to purchase and sell{' '}
        <b>{formatNumber(newestProduct?.nextBatch)}</b> units of{' '}
        <b>{productName || 'this product'}</b>, and provide your best estimate
        for when each payment will be due.
      </span>
    );
  }
}

export default function CreateLine() {
  const mobile = useMobile('sm');
  const { business } = useCompanyContext();
  const { products, lines } = useLinesContext();
  const [newestProduct, setNewestProduct] = useState(null);

  useEffect(() => {
    if (products && products?.length) {
      setNewestProduct(products[products?.length - 1]);
    }
  }, [products, setNewestProduct]);

  return (
    <Stepper
      fetchLines={true}
      hideContent={!(products && business && lines)}
      title={getHeader(mobile)}
      subtitle={getSubTitle(mobile, newestProduct)}
      headerWidth={getLinePageWidth(mobile)}
      contentWidth={getLinePageWidth(mobile)}
    >
      <PageLayout />
    </Stepper>
  );
}
